<template>
  <div class="game-list-scroll">
    <div class="game-grid">
      <game-card
        v-for="(game, index) in games"
        :key="game.id || game.link || index"
        :game="game"
        :image-url="imageUrl"
        :query-string="queryString"
        :rank="index + 1"
      />
    </div>
  </div>
</template>

<script>
import GameCard from './game-card-mobile.vue'

export default {
  name: 'GameListScroll',
  components: {
    GameCard
  },
  props: {
    games: {
      type: Array,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    queryString: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.game-list-scroll {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 40px 20px;

  .game-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 60px 50px;
    width: 100%;
  }
}

@media (max-width: 768px) {
  .game-list-scroll {
    padding: 0 15px 25px 15px;
    .game-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 30px 25px;
    }
  }
}

@media (max-width: 480px) {
  .game-list-scroll {
    padding: 0 15px 20px 15px;
    .game-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 20px 15px;
    }
  }
}
</style>